import { render } from "./ProjectIndex.vue?vue&type=template&id=256e7058"
import script from "./ProjectIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Project/ProjectIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "256e7058"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('256e7058', __exports__)) {
    api.reload('256e7058', __exports__)
  }
  
  module.hot.accept("./ProjectIndex.vue?vue&type=template&id=256e7058", () => {
    api.rerender('256e7058', render)
  })

}


export default __exports__